/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const Pagination = ({ totalPageNumber, setPageNumber, handleOnClickPageNumber }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [inputPageNumber, setInputPageNumber] = useState(1);
    const dispatch = useDispatch();

    useEffect(() => {
        const currentPage = parseInt(searchParams.get("page_number")) || 1;
        setInputPageNumber(currentPage);
    }, [searchParams]);

    const handlePrevClick = () => {
        handleOnClickPageNumber(inputPageNumber - 1);
    };

    const handleNextClick = () => {
        handleOnClickPageNumber(inputPageNumber + 1);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        // Only set input if the value is a number
        if (!isNaN(value) && value !== '') {
            setInputPageNumber(parseInt(value));
        } else if (value === '') {
            setInputPageNumber('');
        }
    };
    
    const handleInputBlur = () => {
        const pageNumber = inputPageNumber;
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPageNumber) {
            handleOnClickPageNumber(pageNumber);
        } else {
            // If input page number exceeds total pages, set to totalPageNumber
            const newPageNumber = pageNumber > totalPageNumber ? totalPageNumber : (pageNumber < 1 || isNaN(pageNumber) ? 1 : pageNumber);
            setInputPageNumber(newPageNumber);
            handleOnClickPageNumber(newPageNumber);
        }
    };

    const handleKeyPress = (e) => {
        // Allow only numbers and the Enter key
        if (e.key === 'Enter') {
            handleInputBlur();
        } else if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
    };

    return (
        <div className="flex items-center ml-5">
            <button
                disabled={inputPageNumber === 1}
                onClick={handlePrevClick}
                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
            >
                <img src="/images/left.svg" alt="icon" />
            </button>
            <input
                type="number"
                value={inputPageNumber}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyPress={handleKeyPress}
                onPaste={handlePaste}
                className="mx-2.5 px-1 py-[1px] border-2 border-[#687182] h-[25px] text-[#171C26] text-sm font-semibold rounded-md w-12 text-center"
                min="1"
                max={totalPageNumber}
            />
            <span className='pr-[10px] text-sm font-semibold text-[#687182]'> <span className='pr-[1px]'>/</span> {totalPageNumber}</span>
            <button
                disabled={inputPageNumber === totalPageNumber}
                onClick={handleNextClick}
                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
            >
                <img src="/images/right.svg" alt="icon" />
            </button>
        </div>
    );
};

export default Pagination;
